/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './startPhoneVerification.defs.js'
export * as $defs from './startPhoneVerification.defs.js'
